import React from 'react';
import { FiArrowUpRight, FiCheck, FiFileText, FiGrid, FiLink, FiMessageSquare, FiMoreHorizontal, FiPlus, FiZap } from 'react-icons/fi';

export default function DashboardPreview() {
  return (
    <div className="home-preview-scene" aria-label="Example AppActs workspace">
      <div className="home-preview-orbit" aria-hidden="true" />
      <div className="home-dashboard">
        <div className="home-window-bar"><span className="home-window-dots" aria-hidden="true"><i /><i /><i /></span><span>appacts / workspace</span><span className="home-preview-label">PREVIEW</span></div>
        <div className="home-dashboard-body">
          <div className="home-preview-sidebar" aria-hidden="true">
            <span className="home-sidebar-logo">a.</span><FiGrid className="is-active" /><FiFileText /><FiLink /><FiMessageSquare /><FiZap />
            <span className="home-sidebar-avatar">Y</span>
          </div>
          <div className="home-preview-content">
            <div className="home-preview-topline"><span>Workspace / Overview</span><FiMoreHorizontal aria-hidden="true" /></div>
            <div className="home-preview-greeting"><div><span>LET'S MAKE IT HAPPEN</span><h2>Your next big thing.</h2></div><span className="home-preview-plus" aria-hidden="true"><FiPlus /></span></div>
            <div className="home-preview-project"><span className="home-project-icon"><FiZap aria-hidden="true" /></span><div><strong>Orbit</strong><span>Your project, all connected.</span></div><span className="home-status-dot">Active</span></div>
            <div className="home-preview-stats"><div><span>Connected tools</span><strong>05 <small>/ 05</small></strong></div><div><span>One workspace</span><strong>∞ <small>possibilities</small></strong></div></div>
            <div className="home-checklist-title"><strong>Your launch checklist</strong><span>3 of 3</span></div>
            <div className="home-preview-progress"><span /></div>
            <div className="home-checklist">
              {[['Privacy policy', 'Published', FiFileText], ['App download link', 'Connected', FiLink], ['Support center', 'Ready', FiMessageSquare]].map(([title, status, Icon]) => (
                <div key={title}><Icon aria-hidden="true" /><span>{title}</span><small>{status}</small><FiCheck className="home-check-icon" aria-hidden="true" /></div>
              ))}
            </div>
          </div>
        </div>
        <div className="home-dashboard-bottom"><span><i /> Everything in one place.</span><FiArrowUpRight aria-hidden="true" /></div>
      </div>
      <div className="home-preview-notification"><span><FiCheck aria-hidden="true" /></span><div><strong>Less setup. More building.</strong><small>Your launch stack, sorted.</small></div><FiZap aria-hidden="true" /></div>
      <span className="home-preview-caption">A little less admin. A lot more possibility.</span>
    </div>
  );
}
